import { render, staticRenderFns } from "./SendMessageSettingEdit.vue?vue&type=template&id=81a1e374&scoped=true&lang=pug"
import script from "./SendMessageSettingEdit.vue?vue&type=script&lang=ts"
export * from "./SendMessageSettingEdit.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageSettingEdit.vue?vue&type=style&index=0&id=81a1e374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a1e374",
  null
  
)

export default component.exports